import { useQuery } from '@tanstack/react-query';
import { Filters } from '$/repositories/supabaseRepository/SupabaseRepository.ts';
import { filtersToStringArray } from '@/utils/filtersToStringArray.ts';
import type { Place } from '$/models/Place.d.ts';
import placeRepository from '@/api/repositories/placeRepository/PlaceRepository.ts';

const usePlaces = (enabled: boolean = true, filters: Filters<Place> | undefined = undefined) => {
  const queryKey = ['places', ...filtersToStringArray(filters)];

  const queryFn = async () => {
    return getAction(filters);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default usePlaces;

async function getAction(filters?: Filters<Place>): Promise<Place[]> {
  const { data, error } = filters
    ? await placeRepository.findMany(filters, {
        order: {
          by: 'created_at',
          ascending: true,
        },
      })
    : await placeRepository.all({
        order: {
          by: 'created_at',
          ascending: true,
        },
      });

  if (error) throw new Error(error.message);

  return data ?? [];
}

